import {
	CAMPAIGN_PROMO,
	ALL_PROMO_BATCH,
	CREATE_PROMO_BATCH,
	UPDATE_PROMO_BATCH,
	REMOVE_PROMO_BATCH,
	ALL_PROMO,
	REMOVE_PROMO,
	ERR_PROMO,
	UPDATE_PROMO,
	UPDATE_ERR_PROMO,
	CREATE_PROMO_BATCH_LOADING,
} from "../actions/actionTypes";

const initialState = {
	campaigns: [],
	promoBatches: [],
	promos: [],
	errors: {},
	updatePromo: {},
	loading: false,
};

export default function promoReducer(state = initialState, action) {

	const { type, payload } = action;
	// console.log(state,"state")
	switch (type) {
		case CAMPAIGN_PROMO:
			return {
				...state,
				campaigns: payload,
				loading: false,
			};
		case ALL_PROMO_BATCH:

			return {
				...state,
				promoBatches: payload,
				loading: false,
			};
		case ALL_PROMO:
			return {
				...state,
				promos: payload,
				loading: false,
			};
		case UPDATE_PROMO_BATCH:
			return {
				...state,
				promoBatches: state.promoBatches.map((promoBatch) =>
					promoBatch.campaign_batch_id === payload.campaign_batch_id
						? { ...payload }
						: promoBatch
				),
				loading: false,
			};
		case CREATE_PROMO_BATCH_LOADING:
			return {
				...state,
				loading: true,
				errors: null,
			};
		case CREATE_PROMO_BATCH:
			return {
				...state,
				// promoBatches: [payload, ...state.promoBatches],
				loading: false,
			};
		case REMOVE_PROMO_BATCH:
			return {
				...state,
				promoBatches: state.promoBatches.filter(
					(promoBatch) => promoBatch.campaign_batch_id !== payload
				),
				loading: false,
			};
		case REMOVE_PROMO:
			return {
				...state,
				promos: state.promos?.data.filter(
					(promo) => promo.client_promo_id !== payload
				),
				loading: false,
			};
		case UPDATE_PROMO:
			return {
				...state,
				updatePromo: payload,
				loading: false,
			};
		case UPDATE_ERR_PROMO:
			return {
				...state,
				errors: payload,
				loading: false,
			};
		case ERR_PROMO:
			return {
				...state,
				errors: payload,
				loading: false,
			};
		default:
			return state;
	}
}
